/** Login, two-step verification, invites, step-up confirmation, code input, one-time secrets, not found. */
export const auth = {
  // Auth layout
  homeLabel: "iCryptoNow home",
  security: "Security",
  support: "Support",
  merchantConsole: "Merchant console",
  panelTitle: "Every deposit and payout, <b>at a glance.</b>",
  panelPoints: ["Live balances on every chain", "Payouts with two-person approval", "API keys and webhooks in one place"],

  // Login
  logIn: "Log in",
  loginLead: "Welcome back. Log in to your merchant console.",
  workEmail: "Work email",
  password: "Password",
  showPassword: "Show password",
  hidePassword: "Hide password",
  show: "Show",
  hide: "Hide",
  enterEmailPassword: "Enter your email and password.",
  forgot: "Forgot your password or lost your authenticator? Ask your account owner to reset it, or <a>contact support</a>.",
  demoHint: "Demo: sign in with any email and password, no two-step code. Start the email with owner@, finance@, developer@ or viewer@ to see that role.",
  mockHint:
    "Mock mode: any email and password work; the code is <code>123456</code>. Try <code>finance@</code>, <code>developer@</code>, <code>viewer@</code>, <code>paused@</code>, <code>offsite@</code>, <code>noaccess@</code>, <code>locked@</code> emails, or password <code>wrong</code>. Invite links: <code>/invite#new</code>, <code>/invite#existing</code>.",

  // Login: second step
  mfaEyebrow: "Step 2 of 2 · Two-step verification",
  mfaTitle: "Enter your code",
  mfaLead: "Enter the 6-digit code from the authenticator app for <b>{email}</b>.",
  enterCode: "Enter the 6-digit code.",
  codeRejectedLogin: "That code didn't work. Wait for the next code and try again.",
  signInTimedOut: "Your sign-in timed out. Please enter your password again.",
  verifyAndLogIn: "Verify and log in",
  useDifferentAccount: "Use a different account",

  // Invite
  invitePanelTitle: "Welcome to the team. <b>Let's get you set up.</b>",
  invitePanelPoints: ["Set your name and password", "Turn on two-step verification", "Start working in under a minute"],
  checkingInvite: "Checking your invite",
  invalidTitle: "This invite link doesn't work",
  invalidBody: "It may have expired (links last 72 hours) or already been used. Ask your account owner to send you a new invite.",
  goToLogIn: "Go to log in",
  progress: "Progress",
  stepAccount: "Your account",
  stepMfa: "Two-step verification",
  joinOrg: "Join {org}",
  email: "Email",
  role: "Role",
  yourName: "Your name",
  confirmPassword: "Confirm password",
  pwTooShort: "Use at least 12 characters.",
  pwTooLong: "Use at most 128 characters.",
  pwMismatch: "Passwords don't match.",
  pwHint: "At least 12 characters. A long passphrase is easiest.",
  enterName: "Enter your name.",
  pwLength: "Your password needs 12 to 128 characters.",
  inviteUsed: "This invite has expired or was already used. Ask for a new one.",

  // Invite: authenticator setup
  enrollTitle: "Turn on two-step verification",
  enrollLead:
    "Scan the QR code with an authenticator app (Google Authenticator, 1Password, Authy…). You'll enter a code from it every time you log in and for sensitive actions.",
  qrAlt: "QR code to add {email} to your authenticator app",
  cantScan: "Can't scan? Enter this key",
  copyKey: "Copy key",
  keyHint: "Account: {email} · Time-based, 6 digits",
  codeFromApp: "Code from the app",
  enterAppCode: "Enter the 6-digit code from the app.",
  codeRejectedEnroll: "That code didn't work. Check the time on your phone and try the next code.",
  confirmAndFinish: "Confirm and finish",
  welcomeToast: "Welcome to {org}! Two-step verification is on.",

  // Invite: existing login
  invitation: "Invitation",
  joinedToast: "You joined {org}",
  sameUserLead: "You're logged in as <b>{email}</b>. Joining adds {org} to your brand switcher; your password and 2FA stay the same.",
  wrongUser: "You're logged in as <b>{current}</b>, but this invite is for <b>{invited}</b>.",
  logOutAndLogInAs: "Log out and log in as {email}",
  existingLead: "You already have an iCryptoNow login. Log in as <b>{email}</b> to join {org}. You'll come back here afterwards.",
  logInToJoin: "Log in to join",

  // Step-up dialog and code input
  authenticatorCode: "Authenticator code",
  enterAuthenticatorCode: "Enter the 6-digit code from your authenticator app.",
  codeRejectedStepUp: "That code didn't work. Wait for a new code and try again.",
  stepUpHint: "Open your authenticator app and enter the current code.",

  // One-time secrets
  copyLabel: "Copy {label}",
  secretWord: "secret",
  signingSecretWord: "signing secret",
  onceTitle: "Copy the {what} now. You won't see it again.",
  onceBody: "We only store a hash. If you lose it, create a new one and update your servers.",

  // Not found
  notFoundTitle: "Page not found",
  notFoundBody: "The page you're looking for doesn't exist or was moved.",
  goToOverview: "Go to overview",

  // Sign-up: confirm the application e-mail (/apply/verify)
  verifyChecking: "Confirming your e-mail…",
  verifyTitle: "E-mail confirmed",
  verifyNumber: "Customer number {number}",
  verifyNext: "Next: set your password and two-step verification.",
  verifyRedirect: "Taking you there in a moment…",
  verifyExpiredTitle: "This link doesn't work any more",
  verifyExpiredBody: "It has expired or was already used. If you already set your password, just log in. Otherwise apply again and we'll send you a new link.",
  applyAgain: "Apply again",
};
